import emojiAnnotationMap from 'emoji-annotation-to-unicode';
import * as React from 'react';

import { imgSrcForEmojiHex } from 'lib/emoji';
import Image from 'components/Image';

import './styles/ShortcodeEmoji.scss';

function imgSrcFor(title: string): string {
  const hex = emojiAnnotationMap[title];
  return imgSrcForEmojiHex(hex);
}

/**
 * Displays an emoji character for a given
 * [annotation](http://unicode.org/emoji/charts/emoji-annotations.html). Note
 * that annotations are a many-to-many relationship, so we use the emoji-
 * annotation-to-unicode map generated from [Github's Emoji
 * API](https://developer.github.com/v3/emojis/).
 *
 * ```example
 * <ShortcodeEmoji text=":mortar_board:" />
 * ```
 *
 * You will rarely use this component directly. Rather, look at `TextWithEntities` and
 * `TextEntities` to parse and convert Emoji for cross-platform support.
 *
 * ```js
 * <TextWithEntities
 *   text={text}
 *   entities={
 *     [].concat(
 *       TextEntities.parseShortcodeEmoji(text),
 *     )
 *   }
 * />
 * ```
 *
 */

type Props = {
  text: string;
};

function ShortcodeEmoji(props: Props) {
  const { text } = props;

  // cut out the leading and trailing colons
  const title = text.slice(1, -1);

  try {
    return (
      <Image
        alt={text}
        title={title}
        disableUserInteraction
        src={imgSrcFor(title)}
        className="ShortcodeEmoji"
      />
    );
  } catch (ex) {
    console.warn('No emoji for shortcode', text);
    return <span>{text}</span>;
  }
}

export default ShortcodeEmoji;
